"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    async: Object,
    directory: Boolean,
    directoryDrop: Boolean,
    dropZone: String,
    enabled: Boolean,
    files: Array,
    localization: Object,
    multiple: Boolean,
    showFileList: Boolean,
    template: String | Function,
    validation: Object,

    // Events
    cancel: Function,
    clear: Function,
    complete: Function,
    error: Function,
    pause: Function,
    progress: Function,
    resume: Function,
    remove: Function,
    select: Function,
    success: Function,
    upload: Function
};